import {pathToRegexp} from 'path-to-regexp'

const AP_PATH = '/Hotel/:slug/:locale?'
const AP_REGEX = pathToRegexp(AP_PATH)
/**
 * AP search behavior should always be used on the AP, use this util in selectors etc.
 * @param pathname - The pathname to check, if not provided, will use window.location.pathname
 * @returns hotelId if the pathname is an accommodation page, null otherwise
 */
export const getHotelIdFromAccommodationPage = (pathname?: string) => {
  if (typeof window === 'undefined') return null
  const location = (pathname || window.location.pathname).split(/[?#]/)[0]
  // AP regex also matches SRP, and some of these hooks are mounted on SRP as well.
  if (location.startsWith('/Hotel/Search')) return null

  const match = AP_REGEX.exec(location)
  return match && match.length > 1 ? match[1] : null
}
